package com.yendo.mx.models


import kotlinx.serialization.Serializable

@Serializable
data class NotificacionFirebase(
    val id: String = "",
    val titulo: String = "",
    val cuerpo: String = "",
    val fecha: Long = 0L,
    val leida: Boolean = false,
    // 🚀 TIPO te sirve para saber qué icono poner (PEDIDO, PROMOCION, SISTEMA)
    val tipo: String = "SISTEMA",
    // 🚀 ACCION te sirve para saber a dónde mandarlo al hacer clic (ej. ID del pedido)
    val accion: String = "",
    val imagen: String? = null
)